module.exports = "https://coursera_assets.s3.amazonaws.com/images/78e208841662987a34c5f4ad0c0cc947.png";